// extracted by mini-css-extract-plugin
export default {"container":"ProductMessage_container__lAM0u","productMessage":"ProductMessage_productMessage__TEZvD","message":"ProductMessage_message__OSdA5","link":"ProductMessage_link__ENjzM"};